import $ from 'jquery';
import Cookies from 'js-cookie';
import BaseRichContentPage from './BaseRichContentPage';

class EventPage extends BaseRichContentPage {
	constructor() {
		super();
		this.initTicketInformationBannerBlock();
		this.initMissingInfoModal();
	}

	loadContent() {
		import(
			/* webpackChunkName: "eventPageContent" */
			'../components/eventPageContent'
		)
		.then(({'default': EventPageContent}) => {
			new EventPageContent(window.eventPageParams);
		});
	}

	initTicketInformationBannerBlock() {
		const $ticketInformationBanner        = $('.ticketInformationBanner'),
		      eventId                         = $ticketInformationBanner.data('eventId'),
		      visitedTicketInformationBanners = JSON.parse(Cookies.get('visitedTicketInformationBanners') || '[]');

		if (!visitedTicketInformationBanners.includes(eventId)) {
			$ticketInformationBanner.show();
		}

		$ticketInformationBanner
			.on('click', '.close', () => {
				visitedTicketInformationBanners.push(eventId);
				$('.ticketInformationBanner, .ticketInformationBannerOpenedBackground').hide();
				Cookies.set(
					'visitedTicketInformationBanners',
					JSON.stringify(visitedTicketInformationBanners),
					{
						'expires': 180
					}
				);
				$('body').removeClass('ticketInformationBannerOpened');
			})
			.on('click', '.show', () => {
				$ticketInformationBanner.addClass('opened');
				$('.card-header, .show.showBtn').hide().after(() => {
					$('.ticketInformationBannerOpenedBackground').toggle();
					$('body').addClass('ticketInformationBannerOpened');
				});
			});
	}
	
	initMissingInfoModal() {
		if (document.getElementById('missingInfoModal')) {
			import(
				'../components/MissingInfoBlock'
			)
			.then(({'default': MissingInfoBlock}) => {
				new MissingInfoBlock({
					'pageType': `Club Page: ${window.eventPageParams.eventLocalizedName}`
				});
			});
		}
	}
}

new EventPage();